import { ceruleanBlue } from 'globalStyles';
import React from 'react';
import Icofont from 'react-icofont';
import styled from 'styled-components';

export const Separator = styled.div`
    height: 1px;
    width: 100%;

    background-color: var(--bs-gray);
`;

const DiamondContainer = styled.div`
    transform: rotate(45deg);
    display: inline-block;

    margin: 0 6px;
`;

export const Diamond = ({ color, ...rest }: { color: string }): JSX.Element => (
    <DiamondContainer>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*// @ts-ignore*/}
        <Icofont icon="square" style={{ color: color }} {...rest} />
    </DiamondContainer>
);

const SeparatorContainer = styled.div`
    position: relative;

    margin-top: 20px;
    margin-bottom: 30px;

    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const HorizontalLine = styled.hr<{ color: string }>`
    position: absolute;
    top: 0;
    left: 0;

    margin-top: 12px;
    margin-bottom: 0;

    width: 100%;

    background-color: ${(props): string => props.color as string};
`;

export function DiamondSeparator({
    color = ceruleanBlue,
    ...rest
}: React.ComponentProps<typeof SeparatorContainer> & {
    color?: string;
}): JSX.Element {
    return (
        <div className="w-75 mx-auto">
            <SeparatorContainer {...rest}>
                <HorizontalLine color={color} />
                <Diamond color={color} />
                <Diamond color={color} />
            </SeparatorContainer>
        </div>
    );
}
